<template>
  <div class="company-details order-mng">
    <div class="company-top-bar " ref="optionsTopBar" >

      <div class="text-right">
        <p class="">
          <button type="submit" @click.prevent="validate" class="btn btn-fill btn-success btn">{{$t('general.update')}}</button>
        </p>
      </div>
    </div>
    <div ref="compDetailsContainer" class="company-wrap" :style="{height: windowHeight - pageTopHeight - navbarHeaderHeight - 1 + 'px'}">
      <div :class="(loading ? 'show-loader' : 'hide-loader')">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg><!---->
        </div>
      </div>
      <div class="card">
        <div class="card-content">
          <h5 class="pad-bt-15">
            <i class="ti-align-left"></i>  {{$t('settingCompany.deliveryLabels')}}
          </h5>
          <div class="row">
            <div class="pad-bt-15 col-md-6" v-for="labelObj in model.delivery_options_labels">
              <label > {{$t('settingCompany.' + labelObj['key'])}} </label>
              <input class="form-control "  
                      type="text" 
                      v-validate="{required: true}"
                      v-model="labelObj['label']" >
            </div>
          </div>
        </div>
      </div>
      <div class="card pad-bt-15" v-for="bussLocation in model.locations_details">
        <div class="card-content">
          <h5 class="pad-bt-15">
            <i class="ti-home"></i> {{$t('settingCompany.bussLoc')}}: {{bussLocation.name}}
          </h5>
          <form>
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
              <el-collapse v-model="activeNames" >
                <template v-for="order in bussLocation.ordering_management">

                <div class="pull-right disable-chck" @click="updateTabs(bussLocation.id + order.type, order.enabled)">
                  <p-checkbox
                    :value="true"
                    v-model="order.enabled"
                    key="order.type"
                    :label="order.label"
                    @click="updateTabs(bussLocation.id + order.type)" 
                   >{{$t('settingsOrdering.enabled')}}</p-checkbox>
                </div>
                <el-collapse-item :title="model.delivery_options_labels[getObjectByElemKeyValue('key', order.type, model.delivery_options_labels)]['label']" :name="bussLocation.id + order.type" class="text-left" :class="order.enabled ? '' : 'disabled'">
                <form>
                      <div class="form-group">
                        <label>{{$t('settingsOrdering.paymentOptions')}}</label>


                        <div class="checkbox mar-bt-20" v-for="(opt, idx) in paymentOptions">
                          <input v-if="idx == 0" type="checkbox" 
                                  :value="opt.payment_id"
                                  :name="bussLocation.id + order.type + 'payment'"
                                  :id="bussLocation.id + order.type + opt.payment_id"
                                  v-validate="{required: true}"
                                  v-model="order.payment_options[opt.payment_id]" 
                                  :disabled="!order.enabled"
                                  >
                          <input v-else  type="checkbox" 
                                  :value="opt.payment_id"
                                  :name="bussLocation.id + order.type + 'payment'"
                                  :id="bussLocation.id + order.type + opt.payment_id"
                                  v-model="order.payment_options[opt.payment_id]" 
                                  :disabled="!order.enabled"
                                  >
                          <label :for="bussLocation.id + order.type + opt.payment_id">{{opt.name}}</label>
                        </div>
                        <label class="text-danger" v-show="errors.has(bussLocation.id + order.type + 'payment')">
                          {{$t('settingsOrdering.paymentOptionsErr')}}
                        </label>
                      </div>
                      <div class="form-group">
                        <label>{{$t('settingsOrdering.minimumOrderValue')}}</label>
                        <input type="number" 
                                min="0" 
                                :name="bussLocation.id + order.type + 'minimum_order_value'" 
                                class="form-control sml" 
                                placeholder="" 
                                v-validate="{required: true, min_value: 0}"
                                :disabled="!order.enabled"
                                v-model="order.minimum_order_value"
                                > <b>{{currency}}</b>
                      </div>
                       <div class="form-group" >
                        <label>{{$t('settingsOrdering.waitingTime')}}</label>  
                        <input type="number" 
                                min="0"
                                :name="bussLocation.id + order.type + 'default_waiting_time'" class="form-control sml" 
                                v-model="order.default_waiting_time" 
                                :disabled="!order.enabled"
                                placeholder="" 
                                v-validate="modelValidate.required">  
                        <label>{{$t('settingsOrdering.minutes')}}</label>
                      </div>
                      <div class="form-group" v-if="order.type === 'delivery'">
                        <label>{{$t('settingsOrdering.shippingCost')}}</label>
                        <input type="number" 
                                min="0" 
                                :name="bussLocation.id + order.type + 'delivery_cost'" 
                                class="form-control sml" 
                                placeholder="" 
                                v-validate="{required: true, min_value: 0}"
                                :disabled="!order.enabled"
                                v-model="order.shipping_cost.cost"
                                > <b>{{currency}}</b>
                      </div>
                      <div class="form-group" v-if="order.type === 'delivery'">
                        <label>{{$t('settingsOrdering.shippingTax')}}</label>
                        <v-select v-model="order.shipping_cost.taxes"
                                  multiple
                                  :options="taxesPerLocation[bussLocation.id]"
                                  value="id"
                                  label="name">
                        </v-select>
                      </div>
          
                       <div class="form-group" v-if="order.type === 'meet_half'">
                        <label>{{$t('settingsOrdering.locations')}}</label>
                        <table class="table">
                          <thead>
                              <tr>
                                <th width="23%">{{$t('settingsOrdering.street')}}</th>
                                <th width="23%">{{$t('settingsOrdering.city')}}</th>
                                <th width="23%">{{$t('settingsOrdering.country')}}</th>
                                <th width="23%">{{$t('settingsOrdering.state')}}</th>
                                <th width="8%"></th>
                              </tr>
                          </thead>
                          <tbody>
                             <tr v-for="(location, idx) in order.locations">
                              <td><input type="text" 
                                          class="form-control" 
                                          :name="bussLocation.id + order.type +'locationstr'+order.type+idx"
                                          :disabled="!order.enabled"
                                          v-validate="modelValidate.required"
                                          v-model="location.street"> </td>
                              <td><input type="text" 
                                          class="form-control" 
                                          :name="bussLocation.id + order.type +'locationcity'+order.type+idx"
                                          :disabled="!order.enabled"
                                          vv-validate="modelValidate.required"
                                          v-model="location.city"> </td>
                              <td>
                                <select v-model="location.country" 
                                        :name="bussLocation.id + order.type +'locationcountry'+order.type+idx"
                                        :disabled="!order.enabled"
                                        v-validate="modelValidate.required"
                                        class="select-primary form-control"
                                        @change="updateCountry(location)">
                                  <option v-for="country in defaults.countries"
                                          class="select-primary"
                                          :value="country.alpha2">{{country.name}}
                                  </option>
                                </select>
                              </td>
                              <td>
                               <template v-if="showStateDrop(location)">
                                   <select v-model="location.state_id"
                                          class="select-primary form-control">
                                    <option v-for="state in getStatesOptions(location)"
                                          class="select-primary"
                                          :value="state.id">{{state.name}}
                                    </option>
                                  </select>
                                </template>
                                <template v-else>
                                  <input type="text" v-model="location.state" name="state" :placeholder="$t('settingsOrdering.state')" class="form-control" v-validate="modelValidate.required">
                                </template>  
                              </td>

                              <td><button class="btn btn-simple btn-icon" @click.prevent="removeLocation(bussLocation.id, idx, order.type)"><i :title="$t('general.remove')" class="ti-close text-danger"></i></button></td> 
                            </tr>
                            <template>
                              <tr >
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td><button :title="$t('general.add')" class="btn btn-icon btn-info" @click.prevent="addNewLocation(bussLocation.id, order.type)"><i class="ti-plus"></i></button></td>
                              </tr>
                            </template>
                          </tbody>
                          <tfoot></tfoot>
                        </table>
                      </div> 
                     <div class="form-group">
                        <label>{{$t('settingsOrdering.availableDays')}}</label>
                        <br/>
                        <label class="text-danger" v-show="errors.has(bussLocation.id + order.type + 'days')">
                          {{$t('settingsOrdering.availableDaysErr')}}
                        </label>
                        <div class="row" v-for="(day, dayIdx) in order.available_days">
                          <div class="col-lg-2 col-md-4 col-sm-4 col-xs-12 padd in-inline-160">
                            <div class="checkbox">
                              <input v-if="dayIdx == 0" type="checkbox" 
                                      :value="day.day"
                                      v-model="day.open"
                                      :name="bussLocation.id + order.type + 'days'"
                                      :id="bussLocation.id + order.type + day.day"
                                      v-validate="{required: true}"
                                      :disabled="!order.enabled"
                                      >
                              <input v-else  type="checkbox" 
                                      :value="day.day"
                                      v-model="day.open"
                                      :name="bussLocation.id + order.type + 'days'"
                                      :id="bussLocation.id + order.type + day.day"
                                      :disabled="!order.enabled"
                                      >
                              <label :for="bussLocation.id + order.type + day.day">{{$t('days.' + day.day) | capitalize}}</label>
                            </div>
                          </div>
                          <div class="col-lg-9 col-md-8 col-sm-8 col-xs-12 padd">
                            from 
                            <el-time-select :disabled="!day.open || !order.enabled"
                                            placeholder="Select time"
                                            :value="day.open_from"
                                            v-model="day.open_from"
                                            v-validate="modelValidate.available_days"
                                            :picker-options="pickerOptions">
                            </el-time-select>
                            to 
                            <el-time-select :disabled="!day.open || !order.enabled"
                                            placeholder="Select time"
                                            :value="day.open_to"
                                            v-model="day.open_to"
                                            v-validate="modelValidate.available_days"
                                            :picker-options="pickerOptions">
                            </el-time-select>
                          </div>
                        </div>
                      </div>

                  </form>
                </el-collapse-item>

                </template>

              </el-collapse>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker, TimeSelect} from 'element-ui'
  import VueTabs from 'vue-nav-tabs'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import vSelect from 'vue-select'
  Vue.component('v-select', vSelect)
  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(VueTabs)

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input
    },
    computed: {
      ...mapFields(['name', 'description', 'sku', 'category_id', 'sub_category_id', 'date_from', 'date_to', 'price', 'quantity'])
    },
    props: {
      defaultData: {},
      modeldata: {}
    },
    watch: {
      defaultData (value) {
        this.defaults = value
      },
      modeldata (value) {
        for (var iLocation in value.locations_details) {
          for (var iOrder in value.locations_details[iLocation].ordering_management) {
            // set default value for locations
            if (value.locations_details[iLocation].ordering_management[iOrder].locations === undefined) {
              value.locations_details[iLocation].ordering_management[iOrder].locations = []
            }
            // set default value for shipping cost object
            if (value.locations_details[iLocation].ordering_management[iOrder].shipping_cost === undefined) {
              value.locations_details[iLocation].ordering_management[iOrder].shipping_cost = []
            }

            // set default values for the available days and hours objects
            for (var iDay in this.days) {
              var day = this.days[iDay]
              if (value.locations_details[iLocation].ordering_management[iOrder].available_days === undefined) {
                value.locations_details[iLocation].ordering_management[iOrder].available_days = []
              }
              var index = this.getObjectByElemKeyValue('day', day, value.locations_details[iLocation].ordering_management[iOrder].available_days)
              if (index === false) {
                value.locations_details[iLocation].ordering_management[iOrder].available_days.push({day: day, open_to: '', open_from: '', open: false})
              } else if (value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open === undefined) {
                if (value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open_to !== '' &&
                    value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open_from !== '') {
                  value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open = true
                } else {
                  value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open = false
                }
              }
            }

            // clean available days -- bug after days number got dubled because of translation
            // let self = this
            // value.locations_details[iLocation].ordering_management[iOrder].available_days = value.locations_details[iLocation].ordering_management[iOrder].available_days.filter(function (value, index, arr) {
            //   return (self.days.indexOf(value.day) !== -1)
            // })
          }
        }

        this.model = value

        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        var self = this
        // get taxes
        this.apiRequest('/settings/taxes', 'GET', data, function (response) {
          if (response.status === true) {
            self.taxes = response.data
            let value = self.model
            let taxesPerLocation = []

            for (var iLocation in value.locations_details) {
              let ordMng = value.locations_details[iLocation].ordering_management
              for (var iOrder in ordMng) {
                if (ordMng[iOrder].type === 'delivery') {
                  // check which taxes are enabled per a specific location
                  taxesPerLocation[value.locations_details[iLocation].id] = []
                  for (var iTax in value.locations_details[iLocation].taxes) {
                    var iTaxData = self.getObjectByElemKeyValue('id', value.locations_details[iLocation].taxes[iTax].id, self.taxes)
                    if (iTaxData !== false) {
                      taxesPerLocation[value.locations_details[iLocation].id].push(self.taxes[iTaxData])
                    }
                  }
                }
              }
            }
            self.taxesPerLocation = taxesPerLocation
          }
        })
      }
    },
    data () {
      return {
        model: this.value || this.modeldata,
        defaults: this.value || this.defaultData, // this.countries
        pickerOptions1: {},
        tabIndex: 0,
        taxes: [],
        taxesPerLocation: [],
        activeNames: [],
        currency: this.$session.get('selectedCompanyData')['currency_iso'],
        modelValidate: {
          'available_days': { required: true },
          'required': { required: true }
        },
        paymentOptions: [
          {
            'payment_id': 'credit_card',
            'name': this.$t('paymentTypes.CARD')
          },
          {
            'payment_id': 'cash',
            'name': this.$t('paymentTypes.CASH')
          }
        ],
        pickerNames: ['date_from', 'date_to'],
        days: [
          'monday',
          'tuesday',
          'wednesday',
          'thursday',
          'friday',
          'saturday',
          'sunday'
        ],
        pickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '23:59'
        },
        newLocation: {
          street: '',
          city: '',
          state: '',
          country: ''
        },
        windowHeight: 0,
        navbarHeaderHeight: 0,
        pageTopHeight: 76,
        loading: true
      }
    },
    created () {
      this.currency = this.getCurrencySymbol(this.currency)
    },
    mounted () {
      this.$nextTick(() => {
        this.doHeightCalculation()
        this.loading = false

        window.addEventListener('resize', () => {
          this.doHeightCalculation()
        })
      })
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.errors.clear()
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveDetails()
          } else {
            // this.activeNames = []
            // check which tabs have errors
            for (var bussLocation of this.model.locations_details) {
              for (var order of bussLocation.ordering_management) {
                var tabTtl = bussLocation.id + order.type
                if (order.enabled && this.errors.items.length) {
                  // check this.errors.items
                  for (var err of this.errors.items) {
                    if (err.field.includes(tabTtl)) {
                      this.activeNames.push(tabTtl)
                    }
                  }
                }
                console.warn(tabTtl)
                // 1nwNDbBEdrp6YzaMpxAoFVuEjw5PXV15489495535c53183100f343_98531065A8hTupick_uppayment
              }
            }
            var self = this
            swal({'text': self.$t('settingsOrdering.notice'), 'type': 'error'})
          }
        })
      },
      doHeightCalculation () {
        this.windowHeight = window.innerHeight
        // this.navbarHeaderHeight = this.$refs.navbarHeader.clientHeight
      },
      showStateDrop (location) {
        var countryIso = location.country
        var countries = this.$session.get('defaultData').countries
        var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)

        if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
          // location.states = countries[countryIdx].states
          return true
        } else {
          return false
        }
      },
      getStatesOptions (location) {
        var countryIso = location.country
        var countries = this.$session.get('defaultData').countries
        var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)

        if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
          return countries[countryIdx].states
        } else {
          return []
        }
      },
      updateCountry (location) {
        location.state = null
        location.state_id = null
      },
      addNewLocation (locId, type) {
        var data = {
          'token': this.$session.get('token'),
          'type': 'hashes'
        }
        var self = this
        this.apiRequest('/helpers', 'GET', data, function (response) {
          if (response.status === true) {
            let newRow = []
            newRow = self.newLocation
            newRow.id = response.data[0].id

            var locIdx = self.getObjectByElemKeyValue('id', locId, self.model.locations_details)
            var typeIdx = self.getObjectByElemKeyValue('type', type, self.model.locations_details[locIdx].ordering_management)

            self.model.locations_details[locIdx].ordering_management[typeIdx].locations.push(newRow)
            console.warn(self.model[typeIdx].locations)
          } else {
            swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      },
      updateTabs (name, enabled) {
        this.$nextTick(function () {
          if (!enabled) {
            this.activeNames = [name]
          } else {
            this.activeNames = []
          }
        })
      },
      removeLocation (locId, idx, type) {
        // var iOrder = this.getObjectByElemKeyValue('type', type, this.model)

        var locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details)
        var typeIdx = this.getObjectByElemKeyValue('type', type, this.model.locations_details[locIdx].ordering_management)

        this.model.locations_details[locIdx].ordering_management[typeIdx].locations.splice(idx, 1)
      },
      saveDetails () {
        this.$nextTick(function () { this.loading = true })
        var companyID = this.$session.get('selectedCompany')
        var currentLocations = []
        var countries = this.$session.get('defaultData').countries
        for (var locIdx in this.model.locations_details) {
          var locData = this.copyObject(this.model.locations_details[locIdx])

          for (var orMngIdx in locData.ordering_management) {
            if (locData.ordering_management[orMngIdx].type === 'meet_half') {
              for (var idx in locData.ordering_management[orMngIdx].locations) {
                let countryIso = locData.ordering_management[orMngIdx].locations[idx].country
                let countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)
                let states = []

                if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
                  states = countries[countryIdx].states
                }

                if (states.length && locData.ordering_management[orMngIdx].locations[idx].state_id) {
                  var state = this.getObjectByElemKeyValue('id', locData.ordering_management[orMngIdx].locations[idx].state_id, states)
                  if (state !== undefined) {
                    locData.ordering_management[orMngIdx].locations[idx].state = states[state].name
                  } else {
                    locData.ordering_management[orMngIdx].locations[idx].state = null
                  }
                }
                delete locData.ordering_management[orMngIdx].locations[idx].states
              }
            }
          }
          currentLocations[locIdx] = locData
        }
        var data = {
          'token': this.$session.get('token'),
          'locations_details': JSON.stringify(currentLocations),
          'delivery_options_labels': JSON.stringify(this.model.delivery_options_labels)
        }

        var self = this
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            self.$nextTick(function () { self.loading = false })
            swal({'text': self.$t('settingsOrdering.saveSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 3000}).catch(() => {})
            self.$session.set('selectedCompanyData', response.data[0])
          } else {
            // self.handleErrors(response.errors)
            self.$nextTick(function () { self.loading = false })
            swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      }
    }
  }
</script>
<style>
  .el-date-editor.el-input{ max-width: 170px; }
  .padd{ padding: 4px 15px; }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/OrderingManagement/OrderingManagement.vue